import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { collection, query, orderBy, onSnapshot, getDoc, doc } from "firebase/firestore";
import { db } from "../firebase";

const NotificationList = styled.div`
  position: fixed;
  top: 50px;
  right: 10px;
  width: 300px;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const NotificationItem = styled.div`
  padding: 10px;
  color: #666;
  border-bottom: 1px solid #eee;
  &:last-child {
    border-bottom: none;
  }
`;

const LikeNotifications = () => {
    const [notifications, setNotifications] = useState([]);
  
    useEffect(() => {
      const fetchNotifications = async () => {
        const postsQuery = query(collection(db, "posts"), orderBy("timestamp", "desc"));
  
        const fetchLikedUsers = async (likedUsers) => {
          const usernames = await Promise.all(
            likedUsers.map(async (userId) => {
              try {
                const userDoc = await getDoc(doc(db, "users", userId));
                return userDoc.exists() ? userDoc.data().displayName || "익명" : "알 수 없는 사용자";
              } catch (error) {
                console.error("Error fetching username:", error);
                return "알 수 없는 사용자";
              }
            })
          );
          return usernames;
        };
  
        const unsubscribe = onSnapshot(postsQuery, async (snapshot) => {
          const notificationsData = await Promise.all(
            snapshot.docs.map(async (doc) => {
              const data = doc.data();
              const likedUsers = data.likedUsers || [];
              const usernames = await fetchLikedUsers(likedUsers);
  
              return {
                id: doc.id,
                postId: doc.id,
                usernames,
                timestamp: data.timestamp?.toDate().toLocaleString(), // 시간 변환
              };
            })
          );
  
          setNotifications(notificationsData);
        });
  
        return unsubscribe;
      };
  
      const unsubscribe = fetchNotifications();

      return () => {
        if (typeof unsubscribe === "function") {
          unsubscribe();
        }
      };
    }, []);
  
  
  return (
    <NotificationList>
      {notifications.map((notification) => (
        <NotificationItem key={notification.id}>
          {notification.usernames.join(", ")}님이 게시글에 좋아요를 눌렀습니다.<br />
          <small>{notification.timestamp}</small>
        </NotificationItem>
      ))}
    </NotificationList>
  );
};

export default LikeNotifications;
